import DiaryListServices from "@/services/DiaryListServices";
import moment from "moment";
import DiaryListConstants from "@/store/constants/diaryListRecords";
import GlobalConstants from "@/store/constants/global"
export default {
  name: "CopyDiaryModal",
  props: [],
  data() {
    return {
      sourceTimePickerOptions: {
        format: "LL",
        useCurrent: true,
        locale: "ja",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle",
        },
        inline: true,
      },
      destTimePickerOptions: {
        format: "LL",
        useCurrent: true,
        locale: "ja",
        icons: {
          time: "far fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle",
        },
        inline: true,
      },
      editor: "",
      sourceDate: moment(new Date()),
      destDate: moment(new Date()),
      selectedSourceDate: null,
      selectedDestDate: null,
      selectedDateDiaries: [],
      validateEditor: true,
      selectedDiaryPeriod: 'daytime',
    };
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent) => {
      if (bvEvent.componentId == "copy-diary-modal") {
        this.getDiaryEditing();
        const diaryEditing = this.$store.getters[DiaryListConstants.GETTERS.getDiariesEditing];
        DiaryListServices.showDateHighLight([], diaryEditing, true);
        this.resetState();
      }
    });
  },
  computed: {
    diaries() {
      return this.$store.getters[DiaryListConstants.GETTERS.getDiariesEditingCopyModal];
    },
    siteSelected: {
      get: function () {
        return this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
      },
      set: function (site) {
        this.$store.commit(DiaryListConstants.COMMIT.setSiteSelected, { site: site });
      }
    },
    canCopy() {
      return this.selectedSourceDate && this.selectedDestDate && this.editor.length > 0 && this.selectedDiaryPeriod;
    },
    diaryPeriodOptions() {
      return [
        { value: 'daytime', text: this.$t('diaryList.periods.daytime') },
        { value: 'nighttime', text: this.$t('diaryList.periods.nighttime') }
      ];
    },
  },
  methods: {
    resetState() {
      this.editor = "";
      this.validateEditor = true;
      this.sourceDate = moment(new Date());
      this.destDate = moment(new Date());
      this.selectedSourceDate = null;
      this.selectedDestDate = null;
      this.selectedDateDiaries = [];
      this.selectedDiaryPeriod = 'daytime';
    },
    sourceUpdate(date) {
      this.sourceDate = date.viewDate;
      this.getDiaryEditing();
    },
    sourceChange(date) {
      this.sourceDate = date.date;
      this.selectedSourceDate = date.date;
      this.updateSelectedDateDiaries();
      DiaryListServices.showDateHighLight([], this.diaries, true);
      setTimeout(() => {
        this.handleSourceDateClick();
      }, 100);
    },
    destUpdate(date) {
      this.destDate = date.viewDate;
    },
    destChange(date) {
      this.destDate = date.date;
      this.selectedDestDate = date.date;
    },
    handleSourceDateClick() {
      const activeElement = document.querySelector("#copy-diary-source-date td.active");
      if (activeElement) {
        activeElement.addEventListener('click', () => {
          this.updateSelectedDateDiaries();
          setTimeout(() => {
            DiaryListServices.showDateHighLight([], this.diaries, true);
            this.handleSourceDateClick();
          }, 100);
        });
      }
    },
    updateSelectedDateDiaries() {
      if (this.selectedSourceDate && this.diaries) {
        const selectedDateStr = this.selectedSourceDate.format('YYYY-MM-DD');
        const sortedDiaries = this.diaries.filter(diary =>
          diary.diaryDate === selectedDateStr
        ).sort((a, b) => new Date(b.editDateTime) - new Date(a.editDateTime));
        // 最新の編集履歴のみ表示する（顧客フィードバック #727）
        this.selectedDateDiaries = sortedDiaries.length > 0 ? [sortedDiaries[0]] : [];
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) {
        return '--:--';
      }
      
      // Java ZonedDateTime 形式（例: 2025-07-06T23:30:09+09:00[Asia/Tokyo]）を
      // moment.js がパースできる形式に変換
      let cleanedDateTime = dateTime;
      if (typeof dateTime === 'string' && dateTime.includes('[')) {
        cleanedDateTime = dateTime.split('[')[0]; // [Asia/Tokyo] 部分を削除
      }
      
      const momentObj = moment(cleanedDateTime);
      if (!momentObj.isValid()) {
        return '--:--';
      }
      
      return momentObj.format('HH:mm');
    },
    postDiary() {
      console.log("📋 CopyDiaryModal: postDiary() 開始");
      console.log("📋 editor:", this.editor);
      console.log("📋 selectedSourceDate:", this.selectedSourceDate);
      console.log("📋 selectedDestDate:", this.selectedDestDate);
      
      if (!this.canCopy) {
        console.log("📋 バリデーションエラー: 必要な情報が不足");
        this.validateEditor = this.editor.length > 0;
        return;
      }
      
      const latestDiary = this.selectedDateDiaries.length > 0 ? this.selectedDateDiaries[0] : null;
      if (!latestDiary) {
        console.log("📋 エラー: 選択された日付に日誌が存在しません");
        return;
      }
      
      console.log("📋 選択された最新日誌データ:", latestDiary);
      console.log("📋 最新日誌の workRecords:", latestDiary.workRecords);
      console.log("📋 workRecords 件数:", latestDiary.workRecords ? latestDiary.workRecords.length : 'undefined');
      
      console.log("📋 確認モーダル表示");
      this.$bvModal.show('confirm-copy-diary-modal');
      const attrToCopyDiary = { 
        sourceDate: this.selectedSourceDate, 
        destDate: this.selectedDestDate, 
        editor: this.editor,
        sourceDiary: latestDiary,
        selectedDiaryPeriod: this.selectedDiaryPeriod
      };
      console.log("📋 attrToCopyDiary:", attrToCopyDiary);
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "copyDiary", orderId: attrToCopyDiary });
      console.log("📋 confirmAttr設定完了");
    },
    changeStateValidateEditor(value) {
      this.validateEditor = value.length != 0;
    },
    getDiaryEditing() {
      this.$store.dispatch(DiaryListConstants.DISPATCH.getDiariesEditingRecordsCopyModal, {
        siteId: this.siteSelected,
        month: this.sourceDate.format("MM"),
        year: this.sourceDate.format("YYYY")
      });
    },
  },
  watch: {
    diaries: function (newDiaries, oldDiaries) {
      this.diaryEditingCurrent = newDiaries;
      this.diaryEditingPrevious = oldDiaries;
      DiaryListServices.showDateHighLight(oldDiaries, newDiaries, true);
      this.updateSelectedDateDiaries();
    },
  },
};
